import type {
  ActivityOpenedResponse,
  CompleteSessionInput,
  SessionCompletionResponse,
  SessionMutationResponse,
  TodayResponse,
  TodaySession,
  UndoSessionCompletionInput,
} from "@learn-flow/contracts";

import { apiRequest } from "../../lib/api.js";

export const todayQueryRoot = ["today"] as const;

export function loadToday(): Promise<TodayResponse> {
  return apiRequest("/api/v1/today");
}

export function markActivityOpened(activityId: string): Promise<ActivityOpenedResponse> {
  return apiRequest(`/api/v1/activities/${activityId}/opened`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export async function completeTodaySession(
  session: TodaySession,
  input: CompleteSessionInput,
): Promise<SessionCompletionResponse> {
  return apiRequest(`/api/v1/sessions/${session.id}/complete`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function undoTodaySession(
  session: TodaySession,
  input: UndoSessionCompletionInput,
): Promise<SessionMutationResponse> {
  return apiRequest(`/api/v1/sessions/${session.id}/undo-completion`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}
